import React from 'react';
import { Switch } from 'react-router-dom';
import Anominizacao from '~/pages/anonimizacao';
import CriacaoDosAssuntosDeContato from '~/pages/CriacaoDosAssuntosDeContato';
import Documento from '~/pages/Documento';
import ExibirHistoricoDeManutencaoDasAtividades from '~/pages/ExibirHistoricoDeManutencaoDasAtividades';
import FAQ from '~/pages/FAQ';
import Helpe from '~/pages/Help';
import Home from '~/pages/Home';
import ListaAuditoria from '~/pages/ListaAuditoria';
import ManterAtividadesTratamentoDados from '~/pages/ManterAtividadesTratamentoDados';
import PoliticaPrivacidade from '~/pages/PoliticaPrivacidade';
import SignIn from '~/pages/SignIn';
import VisualizarDadosDosTitulares from '~/pages/VisualizarDadosDosTitulares';
import Route from '~/routes/Route';

const Routes = () => (
  <Switch>
    <Route exact path="/" component={Helpe} />
    <Route exact path="/:country_company" component={SignIn} />
    <Route path="/:country_company/faq" component={FAQ} isPublic />
    <Route
      path="/:country_company/politica-de-privacidade"
      component={PoliticaPrivacidade}
      isPublic
    />

    <Route exact path="/:country_company/home" component={Home} isPrivate />
    <Route
      path="/:country_company/home/manter-atividades-de-tratamento-de-dados"
      component={ManterAtividadesTratamentoDados}
      isPrivate
    />
    <Route
      path="/:country_company/home/exibir-historico-de-manutencao-das-atividades"
      component={ExibirHistoricoDeManutencaoDasAtividades}
      isPrivate
    />
    <Route
      path="/:country_company/home/lista-de-auditoria"
      component={ListaAuditoria}
      isPrivate
    />
    <Route
      path="/:country_company/home/criacao-dos-assuntos-de-contato"
      component={CriacaoDosAssuntosDeContato}
      isPrivate
    />
    <Route
      path="/:country_company/home/visualizar-dados-dos-titulares"
      component={VisualizarDadosDosTitulares}
      isPrivate
    />
    <Route
      path="/:country_company/home/anonimizacao"
      component={Anominizacao}
      isPrivate
    />
    <Route
      path="/:country_company/home/documentos"
      component={Documento}
      isPrivate
    />
  </Switch>
);

export default Routes;
